import { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import { BrandLogo } from "@/atoms/Logo";
import { NavPhoneIcon, ChevronArrowIcon } from "@/atoms/Icons";
import { accordionHandler, isMobileScreen } from "@/utils/functions";
import {
  servicesData,
  industriesData,
  toolsData,
  integrationsData,
  whyData,
  meganavFooterData,
} from "@/utils/MeganavData";
import { IS_LIVE } from "@/utils/constants";
import { getSiteInfo } from "@/utils/commonUtil";

const MeganavFooter = ({ itemValue, isMobile }) => {
  const item = meganavFooterData[itemValue];

  return (
    <div className="meganav-footer">
      <div className="fx fx--c">
        {!isMobile && (
          <>
            <p className="text--lg bold mb-2 sec-font">{item.title}</p>
            <p className="text mb-5">{item.description}</p>
          </>
        )}
        <a href={item.link} className="btn--link text bold">
          {item.buttonText}
        </a>
      </div>
    </div>
  );
};

const ServicesMeganav = ({ isMobile }) => {
  return (
    <div className={`meganav ${isMobile ? "mobile-dropmenu" : ""}`}>
      <div
        className={`meganav-inner fx col-2 ${isMobile ? "fx--w fx--c" : ""}`}
      >
        <ul className="mr-5">
          {servicesData.slice(0, 3).map((service, index) => (
            <li
              className={
                index === servicesData.slice(0, 3).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx" href={service.href}>
                {service.icon && <service.icon className="icon mr-1" />}
                <div>
                  <p className="sec-font text fw-semibold mb-2-d mb-1 meganav-title">
                    {service.title}
                  </p>
                  <p className="text--sm">{service.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul>
          {servicesData.slice(3).map((service, index) => (
            <li
              className={
                index === servicesData.slice(3).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx" href={service.href}>
                {service.icon && <service.icon className="icon mr-1" />}
                <div>
                  <p className="sec-font text fw-semibold mb-2-d mb-1 meganav-title">
                    {service.title}
                  </p>
                  <p className="text--sm">{service.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <MeganavFooter itemValue={0} isMobile={isMobile} />
    </div>
  );
};

const IndustriesMeganav = ({ isMobile }) => {
  return (
    <div className={`meganav ${isMobile ? "mobile-dropmenu" : ""}`}>
      <ul className="meganav-inner fx fx--c-m fx--c-t fx--sb col-3 fx--w">
        {industriesData.map((industry, index) => (
          <li
            className={index < industriesData.length - 3 ? "mb-5" : ""}
            key={index}
          >
            <a className="meganav-link fx" href={industry.href}>
              {industry.icon && <industry.icon className="icon mr-1" />}
              <div>
                <p className="sec-font text--md fw-semibold mb-2 meganav-title">
                  {industry.title}
                </p>
              </div>
            </a>
          </li>
        ))}
      </ul>
      <MeganavFooter itemValue={1} isMobile={isMobile} />
    </div>
  );
};

const ToolsMeganav = ({ isMobile }) => {
  return (
    <div className={`meganav ${isMobile ? "mobile-dropmenu" : ""}`}>
      <div className="meganav-inner fx fx--c-m fx--c-t">
        <ul className="mr-3">
          {toolsData.slice(0, 2).map((tool, index) => (
            <li
              className={
                index === toolsData.slice(0, 2).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx" href={tool.href}>
                <div>
                  <p className="sec-font text fw-semibold mb-2 meganav-title">
                    {tool.title}
                  </p>
                  <p className="text--sm">{tool.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul>
          {toolsData.slice(2).map((tool, index) => (
            <li
              className={index === toolsData.slice(2).length - 1 ? "" : "mb-6"}
              key={index}
            >
              <a className="meganav-link fx" href={tool.href}>
                <div>
                  <p className="sec-font text fw-semibold mb-2 meganav-title">
                    {tool.title}
                  </p>
                  <p className="text--sm">{tool.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <MeganavFooter itemValue={2} isMobile={isMobile} />
    </div>
  );
};

const IntegrationsMeganav = ({ isMobile }) => {
  return (
    <div className={`meganav ${isMobile ? "mobile-dropmenu" : ""}`}>
      <div className="fx fx--sb fx--w fx--c-m fx--c-t meganav-inner col-4">
        <ul className="fx fx--c">
          {integrationsData.slice(0, 3).map((integration, index) => (
            <li
              className={
                index === integrationsData.slice(0, 3).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx-v" href={integration.href}>
                {integration.icon && <integration.icon className="mr-1 icon" />}
                <div>
                  <p className="sec-font text fw-semibold meganav-title">
                    {integration.title}
                  </p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul className="fx fx--c">
          {integrationsData.slice(3, 6).map((integration, index) => (
            <li
              className={
                index === integrationsData.slice(3, 6).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx-v" href={integration.href}>
                {integration.icon && <integration.icon className="mr-1 icon" />}
                <div>
                  <p className="sec-font text fw-semibold meganav-title">
                    {integration.title}
                  </p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul className="fx fx--c">
          {integrationsData.slice(6, 9).map((integration, index) => (
            <li
              className={
                index === integrationsData.slice(6, 9).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx-v" href={integration.href}>
                {integration.icon && <integration.icon className="mr-1 icon" />}
                <div>
                  <p className="sec-font text fw-semibold meganav-title">
                    {integration.title}
                  </p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul className="fx fx--c">
          {integrationsData.slice(9).map((integration, index) => (
            <li
              className={
                index === integrationsData.slice(9).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx-v" href={integration.href}>
                {integration.icon && <integration.icon className="mr-1 icon" />}
                <div>
                  <p className="sec-font text fw-semibold meganav-title">
                    {integration.title}
                  </p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <MeganavFooter itemValue={3} isMobile={isMobile} />
    </div>
  );
};

const WhyMeganav = ({ isMobile }) => {
  return (
    <div className={`meganav ${isMobile ? "mobile-dropmenu" : ""}`}>
      <div className="fx fx--sb fx--w fx--c-m fx--c-t meganav-inner col-2">
        <ul className="mr-5">
          {whyData.slice(0, 3).map((item, index) => (
            <li
              className={
                index === integrationsData.slice(0, 3).length - 1 ? "" : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx" href={item.href}>
                <div>
                  <p className="sec-font text fw-semibold mb-1 meganav-title">
                    {item.title}
                  </p>
                  <p className="text--sm">{item.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
        <ul>
          {whyData.slice(3, whyData.length).map((item, index) => (
            <li
              className={
                index === integrationsData.slice(3, whyData.length).length - 1
                  ? ""
                  : "mb-6"
              }
              key={index}
            >
              <a className="meganav-link fx" href={item.href}>
                <div>
                  <p className="sec-font text fw-semibold mb-1 meganav-title">
                    {item.title}
                  </p>
                  <p className="text--sm">{item.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <MeganavFooter itemValue={4} isMobile={isMobile} />
    </div>
  );
};

function showMeganav(event) {
  event.currentTarget.classList.add("show-drop");
}

function hideMeganav(event) {
  event.currentTarget.classList.remove("show-drop");
}

function Header({
  className,
  variant = "default",
  isWhiteHeader = false,
  hasHeaderCta = false,
}) {
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const mainDropDowns = useRef(null);
  const navigationToggleBtn = useRef(null);
  const headerElement = useRef(null);
  const [targetCtaPath, setTargetCtaPath] = useState("");
  const franchisePageList = ["/franchise/puroclean"];

  const isFranchisePage = franchisePageList.some((page) =>
    router.asPath.includes(page)
  );

  useEffect(() => {
    const isRegisteredFranchise = document.cookie.includes(
      "isregisteredfranchise"
    );
    setTargetCtaPath(
      isRegisteredFranchise && isFranchisePage
        ? "/franchise/pricing"
        : "/register"
    );
  }, []);

  useEffect(() => {
    setIsMobile(isMobileScreen);
    window.addEventListener("scroll", handleScroll);

    const dropdownContainer = mainDropDowns.current;
    const toggleBtn = navigationToggleBtn.current;
    const dropdowns =
      window.innerWidth > 1024 && dropdownContainer
        ? [...dropdownContainer.closest("ul").children]
        : [];

    for (const mainDropdown of dropdowns) {
      mainDropdown.addEventListener("mouseover", showMeganav);
      mainDropdown.addEventListener("mouseout", hideMeganav);
    }

    if (toggleBtn) {
      if (headerElement.current.classList.contains("navigation-toggled")) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
      toggleBtn.addEventListener("click", mobNavToggle);
    }

    return () => {
      for (const mainDropdown of dropdowns) {
        mainDropdown.removeEventListener("mouseover", showMeganav);
        mainDropdown.removeEventListener("mouseout", hideMeganav);
      }

      if (toggleBtn) {
        toggleBtn.removeEventListener("click", mobNavToggle);
      }

      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setIsScrolled(window.pageYOffset > 0);
  };

  function mobNavToggle() {
    const header = headerElement.current;
    header.classList.toggle("navigation-toggled");
    document.body.classList.toggle("no-scroll");
  }

  const navListData = [
    {
      list: "Services",
      href: "/services",
      meganav: <ServicesMeganav isMobile={isMobile} />,
    },
    {
      list: "Industries",
      href: "/industries",
      meganav: <IndustriesMeganav isMobile={isMobile} />,
    },
    {
      list: "Tools",
      href: "/tools",
      meganav: <ToolsMeganav isMobile={isMobile} />,
    },
    {
      list: "Integrations",
      href: "/integrations",
      meganav: <IntegrationsMeganav isMobile={isMobile} />,
    },
    {
      list: "Why",
      href: "/why",
      meganav: <WhyMeganav isMobile={isMobile} />,
    },
  ];

  if (variant === "default") {
    return (
      <header
        className={`header ${isScrolled ? "white" : ""} ${className}`}
        onScroll={handleScroll}
        ref={headerElement}
      >
        <div className="container fx fx--cv">
          <a href="/" className="brand-logo mr-7">
            <BrandLogo color={isScrolled ? "#33393D" : "white"} />
          </a>

          <div className="left-nav">
            <ul className={`fx-v ${isMobile ? "accordion" : ""}`}>
              {navListData.map((item, index) => (
                <li
                  className={`${
                    index === navListData.length - 1 ? "" : "mr-3"
                  } has-menu ${isMobile ? "accordion-list mobile-nav" : ""}`}
                  key={index}
                  ref={mainDropDowns}
                  onClick={accordionHandler}
                >
                  <span className="main-dropdown fx-v link">
                    <a
                      href={item.href}
                      className="mobile-nav-link has-link mr-1 bold"
                    >
                      {item.list}
                    </a>
                  </span>
                  {isMobile && (
                    <ChevronArrowIcon
                      width="16"
                      height="16"
                      className="accordion-arrow"
                      color="#33393d"
                    />
                  )}
                  {item.meganav}
                </li>
              ))}
            </ul>
          </div>

          <ul className="right-nav fx-v to-right">
            <li className="mr-6-d mr-1">
              <div className="phone-inner">
                <a
                  className="fx-v bold link"
                  href={`tel:${getSiteInfo().SALES_NUMBER_CALL}`}
                  aria-label="Call us at 1-800-461-8535"
                >
                  <NavPhoneIcon className="mr-2 phone" />
                  <span className="number desk" id="spannumber">
                    {getSiteInfo().SALES_NUMBER_DISPLAY}
                  </span>
                </a>
              </div>
            </li>
            <li className="mr-6 desk">
              <a className="fw-semibold link" href={getSiteInfo().LOGIN_URL}>
                Login
              </a>
            </li>
            <li className="desk">
              <a
                className="btn btn--primary btn--sm bold"
                id="pricingBtnHeader"
                href={targetCtaPath}
              >
                See Prices
              </a>
            </li>
            <li className="navigation-toggle desktop-hide">
              <button
                type="button"
                aria-label="navigation-toggle"
                ref={navigationToggleBtn}
              >
                <span className="hamburger">
                  <span></span>
                </span>
              </button>
            </li>
          </ul>
        </div>
      </header>
    );
  }

  if (variant === "mini") {
    const renderBrandLogo = () => {
      if (!isWhiteHeader) {
        return <BrandLogo color="#33393D" />;
      }
      return <BrandLogo color={isScrolled ? "#33393D" : "white"} />;
    };

    const renderStyles = () => (
      <style global jsx>{`
        .header .phone path {
          fill: ${!isWhiteHeader ? "#ff8400" : "#fff"};
        }
        .header .link {
          color: ${!isWhiteHeader ? "#33393d" : "#fff"};
        }
      `}</style>
    );

    return (
      <header
        className={`header ${isScrolled ? "white" : ""} ${className}`}
        onScroll={handleScroll}
        ref={headerElement}
      >
        <div className="container fx fx--cv">
          <a href="/" className="brand-logo mr-7">
            {renderBrandLogo()}
          </a>

          <div className="right-nav fx-v to-right">
            <div className={`phone-inner ${hasHeaderCta ? "mr-4-d" : ""}`}>
              <a
                className="fx-v bold link"
                href={`tel:${getSiteInfo().SALES_NUMBER_CALL}`}
                aria-label="Call us at 1-800-461-8535"
              >
                <NavPhoneIcon className="mr-2-d phone" />
                <span className="number desk" id="spannumber">
                  {getSiteInfo().SALES_NUMBER_DISPLAY}
                </span>
              </a>
            </div>
            {!isMobile && hasHeaderCta && (
              <div className="desk">
                <a className="btn btn--primary btn--sm bold" href="/register">
                  See Prices
                </a>
              </div>
            )}
          </div>
        </div>
        {renderStyles()}
      </header>
    );
  }
}

Header.defaultProps = {
  className: "",
};

export default Header;
